import { ref } from "vue";
import { defineStore } from "pinia";

export const useUiStore = defineStore("ui", () => {
  // --------------- State ---------------
  const pageLoading = ref(true);
  const templateLoading = ref(true);
  const filterLoading = ref(false);
  const windowSize = ref(0);
  const showSearch = ref(false);
  const showCalendar = ref(false);
  const showOptions = ref(false);
  const showMenus = ref(false);
  const showServices = ref(false);
  const locatorIsOpen = ref(false);
  const lastRoute = ref("/");

  // --------------- Actions ---------------
  function setPageLoading(val: boolean) {
    pageLoading.value = val;
  }
  function setTemplateLoading(val: boolean) {
    templateLoading.value = val;
  }
  function setFilterLoading(val: boolean) {
    filterLoading.value = val;
  }
  function setWindowSize(val: number) {
    windowSize.value = val;
  }
  function setSearchStatus(val: boolean) {
    showSearch.value = val;
  }
  function setCalendarStatus(val: boolean) {
    showCalendar.value = val;
  }
  function setOptionsStatus(val: boolean) {
    showOptions.value = val;
  }
  function setShowMenus(val: boolean) {
    showMenus.value = val;
  }
  function setShowServices(val: boolean) {
    showServices.value = val;
  }
  function setLocatorIsOpen(val: boolean) {
    locatorIsOpen.value = val;
  }
  function setLastRoute(val: string) {
    lastRoute.value = val;
  }

  return {
    pageLoading,
    templateLoading,
    filterLoading,
    windowSize,
    showSearch,
    showCalendar,
    showOptions,
    showMenus,
    showServices,
    locatorIsOpen,
    lastRoute,

    setPageLoading,
    setTemplateLoading,
    setFilterLoading,
    setWindowSize,
    setSearchStatus,
    setCalendarStatus,
    setOptionsStatus,
    setShowMenus,
    setShowServices,
    setLocatorIsOpen,
    setLastRoute,
  };
});
